import styled from "styled-components";
import { SelectStatus } from "../../../components/modals/addClientModal/addClientModal.styles";
export const DeleteButton = styled.button`
  display: flex;
  width: 100%;
  padding: 6px 22px;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  border-radius: 2px;
  border: 1.5px solid #b10000;
  color: #b10000;
  background-color: transparent;
  font-size: 1rem;
  font-weight: 600;
  line-height: normal;
`;
export const SelectContract = styled(SelectStatus)`
  margin: 1rem 0;
  background-color: transparent;
  border: 1px solid ${({ theme: { colors } }) => colors.gray300};
  max-width: 250px;
  align-self: flex-start;
  grid-column: 1 / -1;
`;
